<template>
  <div class="error-page">
    <NuxtLayout>
      <page-template class="error-page__content">
        <div class="error-page__body">
          <h1 v-html="message" />
        </div>
        <base-button type="red" @click="goBack">
          {{ $t('oldTranslations.general.back') }}
        </base-button>
      </page-template>
    </NuxtLayout>
  </div>
</template>

<script lang="ts" setup>
import { useMixpanel } from '~/composables/mixpanel.ts';

const { mixpanelTrack } = useMixpanel();
const errorWasSend = ref(false);

const route = useRoute();
const router = useRouter();
const error = useError();
const { t } = useI18n();

onMounted(() => {
  if (errorWasSend.value || !import.meta.client) {
    return;
  }

  console.error('ERROR PAGE:', error.value)
  if (error.value?.statusCode === 404) {
    mixpanelTrack('Error_page_shown', {
      message: error.value?.statusMessage || error.value?.message,
      error_code: error.value?.statusCode,
      page: route.path,
    });
    errorWasSend.value = true;
  }
});

const message = computed(() => error.value?.statusCode === 404 ? t('oldTranslations.general.pageNotFound') : t('oldTranslations.general.defaultError'));
function goBack() {
  router.go(-1);
}
</script>

<style lang="scss" scoped>
.error-page {
  width: 100%;
  height: 100dvh;
  background: $white;

  &:deep(.white-wrapper) {
    flex-grow: 1;
    height: 100%;
  }

  &__content {
    flex-grow: 1;
    padding-bottom: 32px;
  }

  &__body {
    flex-grow: 1;
    width: 100%;

    display: grid;
    place-items: center;

    & h1 {
      text-align: center;
      margin-bottom: 24px;
    }
  }
}
</style>
